(function() {
	'use strict';

	angular.module('receiptApp').controller('AlertDialogController',
			AlertDialogController);

	AlertDialogController.$inject = [ '$scope', '$uibModalInstance' ];

	function AlertDialogController($scope, $uibModalInstance) {
		var alertDlgCtr = this;
		alertDlgCtr.errorMessage = null;
		alertDlgCtr.checkCancel = false;

		alertDlgCtr.cancelReason = function() {
			$uibModalInstance.dismiss('cancel');
		};

		alertDlgCtr.submit = function(content) {
			$uibModalInstance.close(content);
		};

	}
})();
